/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 全部旗舰店
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export default async function (
  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: Array<good.TheaterShopCityInitialDto>;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "get",
    url: `/good/shops/city/all`,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
